import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { getSchoolById } from './actions';


class ModalPreview extends React.Component {
    constructor() {
        super();
        this.state = {
            searchText: '',
        };
    }

    componentWillMount() {

    }

    render() {
        const { visible, data, schoolList } = this.props;
        const label = {
            main : {Full_Name__c: 'Full Name in NRIC', ID_Type__c: 'ID Type', ID_Number__c: 'ID Number',  Date_of_Birth__c: 'Date of Birth', Marital_Status__c: 'Marital Status', Other_Marital_Status__c: 'Other Marital Status', Gender__c: 'Gender', Nationality__c: 'Nationality', Other_Nationality__c: 'Other Nationality', Race__c : 'Race', Other_Race__c: 'Other Race', Postal__c: 'Postal Code', Street__c: 'Street Name', Block__c: 'Block Number', Unit_Number__c: 'Unit Number/House Number', Flat_Type__c: 'Type of Flat', Other_Flat_Type__c: 'Other_Flat_Type__c', Country__c: 'Country', Contact_Number__c: 'Contact Number', Mobile_Phone__c: 'Mobile Phone', Email_Address__c: 'Email Address', Office_Number__c: 'Office Phone', Home_Phone__c: 'Home Phone'},
            bene: {Full_Name__c: 'Full Name in NRIC', ID_Type__c: 'ID Type', ID_Number__c: 'NRIC/Birth Cert Number', Date_of_Birth__c: 'Date of Birth', Gender__c: 'Gender', Race__c: 'Race', Other_Race__c: 'Other Race', Nationality__c: 'Nationality', Other_Nationality__c: 'Other Nationality', Current_School__c: 'School', Current_Level__c: 'Current level', Stream__c: 'Stream', Email_Address__c: 'Email', Relationship_to_Applicant__c: 'Relationship to Applicant', Other_Relationship__c: 'Other Relationship', No_of_Receipts_Approved__c: 'Recommended Months of Payout', Payout_Start__c: 'Recommended Start Date of Payout'},
            other: {Full_Name__c: 'Full Name', ID_Type__c: 'ID Type', ID_Number__c: 'NRIC', Date_of_Birth__c: 'Date Of Birth', Gender__c: 'Gender',Marital_Status__c: 'Marital Status', Other_Marital_Status__c: 'Other Marital Status', Race__c: 'Race', Other_Race__c: 'Other Race', Nationality__c: 'Nationality', Other_Nationality__c: 'Other Nationality', Relationship_to_Beneficiary__c: 'Relationship to Beneficiary', Other_Relationship__c: 'Other Relationship', Monthly_Gross_Income__c: 'Monthly Gross Income', Employment_Status__c: 'Employment Status', Other_Source_of_Income__c: 'Other Source Of Income', Other_Source_of_Income_Amount__c: 'Other Source Of Income Amount', Occupation__c: 'Occupation', Company__c: 'Company', Remarks__c:'Remarks'}
        }
        return (
            <div
                className="modal bs-example-modal-lg"
                tabIndex="-1"
                role="dialog"
                aria-labelledby="modalPreview"
                style={{ display: visible ? 'block' : 'none', overflow: 'auto'}}
            >
                <div className="modal-dialog modal-lg" role="document">
                    <div className="modal-content">
                        <div className="row" style={{ margin: 20 }}>
                            <h2>Are you sure you want to submit this form?</h2>
                            <div className="" style={{color: '#a67100'}}>
                                <p>*Once application is submitted, no further changes are allowed</p>
                            </div>
                            <h4>Data Preview</h4>
                            <hr style={{margin: 0, marginBottom: 16}}/>

                            <div class="panel-group" id="accordion" role="tablist" aria-multiselectable="true">
                                <div class="panel panel-default">
                                    <div class="panel-heading" role="tab" id="headingOne">
                                    <h4 class="panel-title">
                                        <a role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                            Main Applicant
                                        </a>
                                    </h4>
                                    </div>
                                    <div id="collapseOne" class="panel-collapse collapse in" role="tabpanel" aria-labelledby="headingOne">
                                    {Object.keys(data.main).length > 0 &&
                                    <div class="panel-body">
                                        {Object.keys(data.main).map((x,i) => (
                                        <div className="col-lg-4" key={i}>
                                            <p style={{fontWeight : 600, marginBottom: 0}}>
                                                {label['main'][x]}
                                            </p>
                                            <p>
                                                {x === 'Date_of_Birth__c' ? moment(data.main[x]).format('DD/MM/YYYY').toString() : data.main[x]}
                                            </p>
                                            <hr style={{margin:0}}/>
                                        </div>
                                        ))}
                                        
                                    </div>}
                                    </div>
                                </div>
                                <div class="panel panel-default">
                                    <div class="panel-heading" role="tab" id="headingTwo">
                                    <h4 class="panel-title">
                                        <a class="collapsed" role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                            Beneficiary List
                                        </a>
                                    </h4>
                                    </div>
                                    <div id="collapseTwo" class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingTwo">
                                    {data.bene &&
                                    <div class="panel-body">
                                        {data.bene.map((x,i) => (
                                            <div key={i} className="col-lg-12">
                                                {Object.keys(x).filter(y => !['shortid','schoolSubType','RecordTypeId'].includes(y) && x[y]).map((y,j) => (
                                                <div className="col-lg-4" key={j}>
                                                    <p style={{fontWeight : 600, marginBottom: 0}}>
                                                        {label['bene'][y]}
                                                    </p>
                                                    <p>
                                                        {y === 'Date_of_Birth__c' || y === 'Payout_Start__c'  ? moment(x[y]).format('DD/MM/YYYY').toString() : 
                                                            (y === 'Current_School__c' ? getSchoolById(schoolList, x[y]) : x[y]) }
                                                    </p>
                                                    <hr style={{margin:0}}/>
                                                </div>
                                                ))}
                                                <div className="col-lg-12">
                                                    <hr style={{width: '100%', border: '1px solid #000'}}/>
                                                </div>
                                            </div>
                                        ))}
                                    </div>}
                                    </div>
                                </div>
                                <div class="panel panel-default">
                                    <div class="panel-heading" role="tab" id="headingThree">
                                    <h4 class="panel-title">
                                        <a class="collapsed" role="button" data-toggle="collapse" data-parent="#accordion" href="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                            Household Members
                                        </a>
                                    </h4>
                                    </div>
                                    <div id="collapseThree" class="panel-collapse collapse" role="tabpanel" aria-labelledby="headingThree">
                                    {data.other &&
                                    <div class="panel-body">
                                        {data.other.map((x,i) => (
                                            <div key={i} className="col-lg-12">
                                                <h6>{x.Main_Applicant__c ? 'Main Applicant' : 'Other Member'}</h6>
                                                {Object.keys(x).filter(y => y !== 'Main_Applicant__c' && x[y]).map((y,j) => (
                                                <div className="col-lg-4" key={j}>
                                                    <p style={{fontWeight : 600, marginBottom: 0}}>
                                                        {label['other'][y]}
                                                    </p>
                                                    <p>
                                                        {y === 'Date_of_Birth__c' ? moment(x[y]).format('DD/MM/YYYY').toString() : x[y]}
                                                    </p>
                                                    <hr style={{margin:0}}/>
                                                </div>
                                                ))}
                                                <div className="col-lg-12">
                                                    <hr style={{width: '100%', border: '1px solid #000'}}/>
                                                </div>
                                            </div>
                                        ))}
                                    </div>}
                                    </div>
                                </div>
                            </div>                  
                        </div>
                        <div className="modal-footer">
                            <button
                                className="btn btn-danger"
                                type="button"
                                style={{
                                    border: '1px solid #c44e4e',
                                    backgroundColor: '#8e1818',
                                    backgroundImage: 'linear-gradient(to right, #8e1818, #c44e4e)'
                                }}
                                onClick={() => {
                                    this.props.onClose();
                                }}
                            >
                                Cancel
                            </button>
                            <button
                                className="btn btn-info"
                                type="button"
                                onClick={() => {
                                    this.props.onSubmit();
                                }}
                            >
                                Submit
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


ModalPreview.propTypes = {
    onClose: PropTypes.func.isRequired,
};

export default ModalPreview;



//////////////////
// WEBPACK FOOTER
// ./src/components/Portal/Registration/ModalPreview.js
// module id = 1020
// module chunks = 0